import { useState, useEffect, forwardRef, useRef } from 'react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import "./CreateLeaves.css"
import { createLeaveMaster, getLeaveMaster, updateLeaveById, deleteLeaveById, multiDeleteLeaveMaster, uploadLeaveMasterFile } from './../../../../../services/register_redux/register_actions/Leave.action';
import { checkLeaveMasterDuplicate } from './../../../../../services/register_redux/register_api_services/Leave.api';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import $ from 'jquery';
import { getStates } from "./../../../../../services/global_redux/globale_actions/States.action";
import files from "./../../../../../assets/templates/register_template/Leave_master.xlsx"
import { getUserRole} from "./../../../../../services/global_redux/globale_actions/Role.action"
import { Modal } from 'react-bootstrap';
import into_icon from "../../../../../assets/global_assets/create_data_imgs/into_icon.png"

import ImportFileform from '../../../../reUsableTemplates/ImportFileform/ImportFileform'
import EditableTable from '../../../../reUsableTemplates/EditableTable/EditableTable'
import { IoCheckmarkSharp } from "react-icons/io5";
import role_table_title_icon from "./../../../../../assets/global_assets/role_imgs/role-table-title-icon.png";
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function CreateLeaves({ showSnackbar, setLoading }) {
    const [data, setData] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [editableRow, setEditableRow] = useState(null);
    const dispatch = useDispatch();
    const [openaddsingle, setOpenaddsingle] = useState(false);
    const [statedata, setstate] = useState([]);
    const [activeForm, setActiveForm] = useState(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [checkedItemCount, setCheckedItemCount] = useState(0);
    const [order, setorder] = useState('ASC');
    const [editedValues, setEditedValues] = useState(null);
    const [openeditalert, setOpeneditalert] = useState(false);
    const [opendeletealert, setopendeletealert] = useState(false);
    const [opendeleteallalert, setopendeleteallalert] = useState(false);
    const [checkState, setCheckState] = useState(false);
    const [deleteclientid, setdeleteclientid] = useState(null);
    const [displayerror, setDisplayerror] = useState([]);
    const [displayerroralert, setDisplayerroralert] = useState(false);
    const [expandedStates, setExpandedStates] = useState({});
    const [checkCreate, setCheckCreate] = useState(false);
    const [checkEdit, setCheckEdit] = useState(false);
    const [checkDelete, setCheckDelete] = useState(false);
    const initialClientDataInput = {
        state: { value: '', type: 'text' },
        leave_code: { value: '', type: 'text' },
        display_leave_code: { value: '', type: 'text' },
        leave_name: { value: '', type: 'text' },
        requires_balance_calculation: { value: '1', type: 'number' },
        credit_limit: { value: '', type: 'number' },
        leave_carry: { value: '', type: 'text' },
        leave_carry_val: { value: '', type: 'number' },
        year_end_month: { value: '', type: 'number' },
        credit_base: { value: '', type: 'number' },
        // credit_on: { value: '', type: 'text' },
        joined_before_credit: { value: '', type: 'text' },
        joined_after_credit: { value: '', type: 'number' },
        gender_based: { value: '', type: 'text' },
    };
    const headers = [
        { value: 'State', key: 'state', input: 'state', readOnly: false },
        { value: 'Is ML (Maternity Leave)', key: 'is_ml', input: 'is_ml', readOnly: false },
        { value: 'Leave Code', key: 'leave_code', input: 'leave_code', readOnly: false },
        { value: 'Display Leave Code', key: 'display_leave_code', input: 'text', readOnly: false },
        { value: 'Leave Name', key: 'leave_name', input: 'text', readOnly: false },
        { value: 'Requires Balance Calculation', key: 'requires_balance_calculation', input: 'requires_balance_calculation', readOnly: false },
        { value: 'Credit Limit', key: 'credit_limit', input: 'number', readOnly: false },
        { value: 'Leave Carry', key: 'leave_carry', input: 'leave_carry', readOnly: false },
        { value: 'Leave Carry Value', key: 'leave_carry_val', input: 'number', readOnly: false },
        { value: 'Year End Month', key: 'year_end_month', input: 'year_end_month', readOnly: false },
        { value: 'Credit Base', key: 'credit_base', input: 'credit_base', readOnly: false },
        // { value: 'Credit On', key: 'credit_on', input: 'credit_on', readOnly: false },
        { value: 'Joined Before Credit', key: 'joined_before_credit', input: 'joined_before_credit', readOnly: false },
        { value: 'Joined After Credit', key: 'joined_after_credit', input: 'joined_after_credit', readOnly: false },
        { value: 'Gender Based', key: 'gender_based', input: 'gender_based', readOnly: false },
    ];

    const [actionChecked, setActionChecked] = useState("");
    
      
    const [formData, setFormData] = useState(initialClientDataInput);
    const [file, setFile] = useState(null);
    const [isML, setIsML] = useState(false);
    const addsinglehandleClose = () => {
        setOpenaddsingle(false);
        setIsFormOpen(false);
        setActiveForm(null);
        setIsML(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const stateVal = getFormVal(formData.state);
        const codeVal = getFormVal(formData.leave_code);
        const exists = data.some(item => (
            item.state === stateVal && item.leave_code === codeVal
        ));
        let isDuplicate = exists;
        if (!exists) {
            try {
                const res = await checkLeaveMasterDuplicate(stateVal, codeVal);
                isDuplicate = res.duplicate;
            } catch (_) {}
        }
        setCheckState(isDuplicate);
        if (!isDuplicate) {
            try {
                // Flatten formData so backend receives plain values (handles { value, type } structure)
                let payload = Object.fromEntries(
                    Object.keys(formData).map((k) => [k, getFormVal(formData[k])])
                );
                if (isML) {
                    payload = {
                        state: payload.state,
                        leave_code: payload.leave_code,
                        display_leave_code: payload.display_leave_code,
                        leave_name: payload.leave_name,
                        credit_limit: payload.credit_limit,
                        is_ml: true,
                        requires_balance_calculation: '1',
                        leave_carry: '',
                        leave_carry_val: '',
                        year_end_month: '',
                        credit_base: '2', // Annually: ML credited once a year via leave opening balance, not monthly
                        credit_on: '',
                        joined_before_credit: '',
                        joined_after_credit: '',
                        gender_based: '',
                    };
                }
                const response = await dispatch(createLeaveMaster(payload));

                if (response && response.success) {
                    setLoading(false);
                    showSnackbar('Leave added successfully!', 'success');
                    addsinglehandleClose();
                    setFormData(initialClientDataInput);
                    fetchClients();
                    setActionChecked("create");
                } else {
                    setLoading(false);
                    const errMsg = typeof response.message === 'string' ? response.message : (response.message?.error || response.message?.message || 'Unknown error');
                    showSnackbar(`Failed to add leave: ${errMsg}`, 'error');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error adding client:', error.message);
                showSnackbar(`Failed to add leave: ${error.message}`, 'error');
            }
        }
    };
    const getFormVal = (v) => (v && typeof v === 'object' && 'value' in v) ? v.value : (v ?? '');
    const checkDuplicateRef = useRef(null);

    // ML (Maternity Leave): only State, Leave code, Display leave code, Leave name, Credit limit are mandatory and visible
    const mlOnlyKeys = ['state', 'leave_code', 'display_leave_code', 'leave_name', 'credit_limit'];
    const isMLFieldVisible = (key) => {
        if (isML) return mlOnlyKeys.includes(key);
        return true;
    };
    const isFieldRequired = (key) => {
        
        if (isML) return mlOnlyKeys.includes(key);
        const isDisplayOnly = getFormVal(formData.requires_balance_calculation) === '0' || getFormVal(formData.requires_balance_calculation) === '';
        const whenDisplayOnly = ['state', 'leave_code', 'display_leave_code', 'leave_name', 'requires_balance_calculation'];
        if (isDisplayOnly) return whenDisplayOnly.includes(key);
        return true; // When Yes: all fields required
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, "");
        const updates = { ...formData, [id]: trimmedValue };
        if (id === 'leave_carry' && trimmedValue !== '1') {
            updates.leave_carry_val = '';
        }
        setFormData(updates);
        if (id === 'state' || id === 'leave_code') setCheckState(false);
    };

    useEffect(() => {
        const stateVal = getFormVal(formData.state);
        const codeVal = getFormVal(formData.leave_code);
        if (!stateVal.trim() || !codeVal.trim()) {
            setCheckState(false);
            return;
        }
        if (checkDuplicateRef.current) clearTimeout(checkDuplicateRef.current);
        checkDuplicateRef.current = setTimeout(async () => {
            try {
                const res = await checkLeaveMasterDuplicate(stateVal, codeVal);
                setCheckState(res.duplicate);
            } catch (_) {
                setCheckState(false);
            }
            checkDuplicateRef.current = null;
        }, 400);
        return () => {
            if (checkDuplicateRef.current) clearTimeout(checkDuplicateRef.current);
        };
    }, [formData.state, formData.leave_code]);
    const handleKeyDown = (e) => {
      if (e.key === " " && e.target.value.length === 0) {
        e.preventDefault();
      }
    };

    const handleFormToggleSingleDataEntry = (form) => {
        setActiveForm(form)
        if (form == "AddSingleclient") {
            addsinglehandleClickOpen();
        }
        setIsFormOpen(true);
    };
    const addsinglehandleClickOpen = () => {
        setCheckState(false);
        setOpenaddsingle(true);
    };
    const fetchState = async () => {
        try {
            const response = await dispatch(getStates());
            setstate(response.data.states);
            console.log("ssaa", response.data.states);
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    }
    useEffect(() => {

        fetchState();
    }, [dispatch]);
    const handleSaveClick = async (e) => {
        setOpeneditalert(false);
        setLoading(true);
        try {
            const response = await dispatch(updateLeaveById(editedValues.id, editedValues));
            if (response.success) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                fetchClients();
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
        setEditableRow(null);
    };


    // const handleFileUpload = async () => {
    //     console.log("file", file);
    //     if (file) {
    //         setLoading(true);
    //         try {
                // const formData = new FormData();
                // formData.append('file', file);
    //             const response = await dispatch(uploadLeaveMasterFile(formData));
    //             console.log(response);
    //             if (response.success == true) {
    //                 showSnackbar(response.message.data.message, 'success');
    //                 setLoading(false);
    //                 fetchClients();
    //                 setFile(null);
    //                 setIsFormOpen(false);
    //                 setActiveForm(null);
    //             } else {
    //                 // console.log("errr",response);
    //                 // setDisplayerror(response.message.error);
    //                 // setDisplayerroralert(true)
    //                 showSnackbar(response.message.error, 'warning');
    //                 setLoading(false);
    //                 // console.log('statussss',displayerror)
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };

   
   const downloadBase64Excel = (contentBase64, filename) => {
       try {
           // Decode base64 to binary
           const byteCharacters = atob(contentBase64);
           const byteNumbers = new Array(byteCharacters.length);
           
           for (let i = 0; i < byteCharacters.length; i++) {
               byteNumbers[i] = byteCharacters.charCodeAt(i);
           }
           
           const byteArray = new Uint8Array(byteNumbers);
           const blob = new Blob([byteArray], { 
               type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
           });
           
           // Create download link
           const url = URL.createObjectURL(blob);
           const a = document.createElement('a');
           a.href = url;
           a.download = filename || 'leave_configuration_failed_rows.xlsx';
           document.body.appendChild(a); // Required for Firefox
           a.click();
           
           // Cleanup
           document.body.removeChild(a);
           URL.revokeObjectURL(url);
           
           console.log('Error file downloaded successfully:', filename);
       } catch (e) {
           console.error('Download failed:', e);
           showSnackbar('Failed to download error file. Please try again.', 'error');
       }
   };
   
   const handleFileUpload = async () => {
       if (!file) {
           showSnackbar('Please select a file to upload', 'warning');
           return;
       }
       
       setLoading(true);
       
       try {
           const response = await dispatch(uploadLeaveMasterFile(file));
           console.log("Upload leave configuration response:", response);
           
           // ============================================================
           // HANDLE SUCCESS RESPONSE (status 200)
           // ============================================================
           if (response.success === true) {
               const data = response.data; // This is the backend response object
               
               console.log("Response data:", data);
               
               // Check if we have the expected response structure
               if (!data) {
                   showSnackbar('Unexpected response format', 'error');
                   setLoading(false);
                   return;
               }
               
               // Extract counts
               const insertedCount = data.inserted_count || 0;
               const failedCount = data.failed_count || 0;
               const totalRows = insertedCount + failedCount;
               
               // CASE 1: Full success (all rows inserted)
               if (insertedCount > 0 && failedCount === 0) {
                   showSnackbar(
                       data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                       'success'
                   );
                   
                   // Refresh the data table
                   fetchClients();
                   setFile(null);
               }
               
               // CASE 2: Partial success (some rows inserted, some failed)
               else if (insertedCount > 0 && failedCount > 0) {
                   showSnackbar(
                       `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                       `${failedCount} record(s) failed. Downloading error file...`,
                       'warning',
                       6000 // Show for 6 seconds
                   );
                   
                   // Download error file
                   if (data.error_file && data.error_file.content_base64) {
                       downloadBase64Excel(
                           data.error_file.content_base64, 
                           data.error_file.filename
                       );
                   } else {
                       console.warn('No error file in response despite failed rows');
                   }
                   
                   // Refresh the data table (to show successfully inserted rows)
                   fetchClients();
                   // Don't clear the file - user might want to fix and re-upload
               }
               
               // CASE 3: Complete failure (all rows failed)
               else if (insertedCount === 0 && failedCount > 0) {
                   showSnackbar(
                       `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                       `Downloading error file with details...`,
                       'error',
                       6000
                   );
                   
                   // Download error file
                   if (data.error_file && data.error_file.content_base64) {
                       downloadBase64Excel(
                           data.error_file.content_base64, 
                           data.error_file.filename
                       );
                   } else {
                       console.warn('No error file in response despite all rows failing');
                       // Fallback: show the message if available
                       if (data.message) {
                           showSnackbar(data.message, 'error', 8000);
                       }
                   }
               }
               
               // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
               else {
                   showSnackbar(
                       data.message || 'Upload completed with unexpected result', 
                       'warning'
                   );
               }
               
               setLoading(false);
           }
           
           // ============================================================
           // HANDLE ERROR RESPONSE (non-200 status)
           // ============================================================
           else {
               const errorMsg = response.error || 'Upload failed';
               
               // Handle different error types
               if (typeof errorMsg === 'string') {
                   showSnackbar(errorMsg, 'error');
               } else if (Array.isArray(errorMsg)) {
                   // If backend returns array of errors
                   const displayError = errorMsg.slice(0, 3).join('; ') + 
                       (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                   showSnackbar(displayError, 'error');
               } else if (typeof errorMsg === 'object' && errorMsg.error) {
                   showSnackbar(errorMsg.error, 'error');
               } else {
                   showSnackbar('An error occurred during upload', 'error');
               }
               
               setLoading(false);
           }
           
       } catch (error) {
           // This catches any unexpected errors in the frontend code
           console.error('Upload error:', error);
           showSnackbar('An unexpected error occurred. Please try again.', 'error');
           setLoading(false);
       }
   };
   
   
    

    const handleDeleteallClick = async (id) => {
        setLoading(true);
        setopendeleteallalert(false);
        try {
            const response = await dispatch(multiDeleteLeaveMaster(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchClients();
                setFile(null);
                setIsFormOpen(false);
                setActiveForm(null);
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handledeleteallClosealert = () => {
        setopendeleteallalert(false);
    }
    const handleCloseeditalert = () => {
        setOpeneditalert(false);
    };
    const fetchClients = React.useCallback(async () => {
        try {
            const response = await dispatch(getLeaveMaster());
            setData(response.data);
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchClients();
    }, [fetchClients]);
    const handledeleteClosealert = () => {
        setopendeletealert(false);
    };
    const setDisplayerroralertconsta = () => {
        setDisplayerroralert(false)
    }
    const handleDeleteClick = async (id) => {
        setLoading(true);
        setopendeletealert(false);
        try {
            const response = await dispatch(deleteLeaveById(id));
            if (response.success) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setOpeneditalert(false);
                fetchClients();

                setOpeneditalert(false);
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
        setEditableRow(null);

    };

    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());
                    const rawPermissions = response?.data?.permissions;
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                ? JSON.parse(rawPermissions[0])
                : rawPermissions;
            parsedPermissions.forEach((item) => {
              if (item.section === "Configuration" && item.module === "Leave Configuration") {
                    setCheckCreate(item.action.create);
                    setCheckEdit(item.action.edit);
                    setCheckDelete(item.action.delete);
              }})
                

        } catch (err) {
          console.error("Failed to fetch states:", err);
        }

    };
    useEffect(() => {
      getUserPermission();
    }, [dispatch]);
    return (
        <div className="container-fluid">
        {/* <div className="col-md-12 py-3"> */}
            {/* <div className="card "> */}
                
        {checkCreate &&
        <ImportFileform
            setFiledata={setFile}
            title={'Leave Configuration'}
            filestemp={files}
            handleFileUpload={handleFileUpload}
            File={file}

        />
        }
        
      <EditableTable      
        header={headers}
        mainIcon={role_table_title_icon}
        title={'Leave Configuration'}
        data={data}
        setEditableRow={setEditableRow}
        setEditedValues={setEditedValues}
        handledeleteClickOpenalert={handleDeleteClick}
        editableRow={editableRow}
        setLoading={setLoading}
        editedValues={editedValues}
        getEditPermission = {checkEdit}
        getDeletePermission = {checkDelete}
        date={false}
        submitdelete={handleDeleteallClick}
        handleSaveClick={handleSaveClick}
        showSnackbar={showSnackbar}
        actionChecked={actionChecked}
        setActionChecked={setActionChecked}
        createOrfilterComp={
          <>
            {checkCreate &&
            <>
              <button
                onClick={() => handleFormToggleSingleDataEntry('AddSingleclient')}
                disabled={isFormOpen}
                >
                    <b>Add Leave Configuration</b>
                </button>
            </>
            }      
          </>                  
        }
      />

          
    <Modal 
      show={openaddsingle} 
      onHide={addsinglehandleClose} 
      centered 
      dialogClassName="custom-modal-dialog"
      backdrop="static"
      keyboard={false}
      style={{ zIndex: "9999" }}
      className='bg-transparent'
    >
    <div className="row d-flex justify-content-center align-items-center w-100 bg-transparent " style={{ marginTop:"10px" }}>
      <div className="bg-white createUnitTableMainContainer text-white " style={{ minWidth: "90vw",height:"90vh" ,padding:"5px",borderRadius:"10px",overflow:"hidden",marginLeft:"20px"}}>
      <div className="row  rounded">
          <div className="col-md-12">
          <div className="row">
            <div className="close-btn-div">
                <button type="button" className=" float-end bg-light  " onClick={addsinglehandleClose} aria-label="Close"><img src={into_icon} alt="" /></button>
            </div>
            </div>
            <div className="row px-3">
                <div className="card-body-changes">
                <form onSubmit={handleSubmit}>
                    <div className="col-md-12">
                        {checkState ? <><p className='text-danger'>Please check the state and the leave code (this leave code for the state is already exist)</p></> : <></>}
                        <div className="row">
                            {Object.keys(formData).map((key) => {
                                if (!isMLFieldVisible(key)) return null;
                                if (key === 'leave_carry_val' && getFormVal(formData.leave_carry) !== '1') return null;
                                if (key === 'leave_code') {
                                    return (
                                        <React.Fragment key={key}>
                                            <div className="col-md-3 pt-4">
                                                {/* <label className="d-flex align-items-center gap-2 mb-0 mt-1">
                                                    <input
                                                        type="checkbox"
                                                        checked={isML}                                                        
                                                        style={{ transform: "scale(2)", accentColor: "#4CAF50" }}
                                                        onChange={(e) => setIsML(e.target.checked)}
                                                    />
                                                    <b>Is ML (Maternity Leave)</b>
                                                </label> */}
                                                <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
    <input
        type="checkbox"
        checked={isML}
        onChange={(e) => setIsML(e.target.checked)}
        style={{ display: "none" }}
    />

    <div
        style={{
            width: "25px",
            height: "25px",
            border: "1px solid #aaa",
            borderRadius: "3px",
            backgroundColor:"white"
        }}
    >
        {isML && <span style={{ fontSize: "25px",marginTop:"-10px" }}><IoCheckmarkSharp style={{ color: "#023fa7" }}/></span>}
    </div><b className='ms-1'>Is ML (Maternity Leave)</b>
</label>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <label htmlFor={key}>
                                                    <b>
                                                        {key.replace(/_/g, ' ')
                                                            .replace(/([a-z])([A-Z])/g, '$1 $2')
                                                            .replace(/^./, (str) => str.toUpperCase())}
                                                        {isFieldRequired(key) && <span className="text-danger">*</span>}
                                                    </b>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control mt-1"
                                                    id={key}
                                                    name={key}
                                                    placeholder="e.g. SL, PL, EL"
                                                    value={getFormVal(formData[key])}
                                                    onChange={handleChange}
                                                    onKeyDown={handleKeyDown}
                                                    required={isFieldRequired(key)}
                                                />
                                            </div>
                                        </React.Fragment>
                                    );
                                }
                                return (
                                    <>
                                    {isFieldRequired(key) && 
                                        <div className="col-md-3 mb-3" key={key}>
                                    <label htmlFor={key}>
                                        <b>
                                            {key.replace(/_/g, ' ')
                                                .replace(/([a-z])([A-Z])/g, '$1 $2')
                                                .replace(/^./, (str) => str.toUpperCase())}
                                            {isFieldRequired(key) && <span className="text-danger">*</span>}
                                        </b>
                                    </label>
                                    {key === 'state' ? (
                                        <select
                                            className="form-control mt-1"
                                            id={key}
                                            name={key}
                                            value={getFormVal(formData[key])}
                                            onChange={handleChange}
                                            required={isFieldRequired(key)}
                                        >
                                            <option value="">--Select--</option>
                                            {statedata ? (
                                                statedata.map((item) => (
                                                    <option key={item.state_name} value={item.state_name}>
                                                        {item.state_name}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value=" ">No states available</option>
                                            )}
                                        </select>
                                    ) : key === 'leave_carry' ? (
                                        <select name={key} id={key} onChange={handleChange} className="form-control mt-1" required={isFieldRequired(key)}>
                                            <option value=" ">--select--</option>
                                            <option value="1">Yes</option>
                                            <option value="2">No</option>
                                        </select>
                                    ) : key === 'requires_balance_calculation' ? (
                                        <select name={key} id={key} onChange={handleChange} className="form-control mt-1"  required>
                                            <option value="">--select--</option>
                                            <option value="1">Yes (PL, SL, ML, CL, EL)</option>
                                            <option value="0">No - Display only (COMP OFF, LOP, WFH)</option>
                                        </select>
                                    ) : key === 'year_end_month' ? (
                                        <select name={key} id={key} onChange={handleChange} className="form-control mt-1" required={isFieldRequired(key)}>
                                            <option value=" ">--select--</option>
                                            <option value="1">March</option>
                                            <option value="2">December</option>
                                        </select>
                                    ) : key === 'gender_based' ? (
                                        <select name={key} id={key} onChange={handleChange} className="form-control mt-1" required={isFieldRequired(key)}>
                                            <option value=" ">--select--</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                            <option value="3">All</option>
                                        </select>
                                    ) : key === 'joined_before_credit' || key === 'joined_after_credit' ? (
                                        <select name={key} id={key} onChange={handleChange} className="form-control mt-1" required={isFieldRequired(key)}>
                                            <option value="">--select--</option>
                                            <option value="1">Full</option>
                                            <option value="2">Half</option>
                                            <option value="3">Zero</option>
                                        </select>
                                    ) : key === 'credit_base' ? (
                                        <select name={key} id={key} onChange={handleChange} className="form-control mt-1" required={isFieldRequired(key)}>
                                            <option value="">--select--</option>
                                            <option value="1">Monthly</option>
                                            <option value="2">Annually</option>
                                        </select>
                                    ) : key === 'credit_on' ? (
                                        <select name={key} id={key} onChange={handleChange} className="form-control mt-1" required={isFieldRequired(key)}>
                                            <option value="">--select--</option>
                                            <option value="1">Begining of Base Value</option>
                                            <option value="2">End of Base Value</option>
                                        </select>
                                    )  : key === 'credit_limit' || key === "leave_carry_val"? (
                                        <input
                                            type='number'
                                            className="form-control mt-1"
                                            step='any'
                                            id={key}
                                            name={key}
                                            value={getFormVal(formData[key])}
                                            onChange={handleChange}
                                            onKeyDown={handleKeyDown}
                                            required={isFieldRequired(key)}
                                            min={0}
                                        />
                                    ) : (
                                        <input
                                            type={formData[key].type || 'text'}
                                            className="form-control mt-1"
                                            id={key}
                                            name={key}
                                            value={getFormVal(formData[key])}
                                            onChange={handleChange}
                                            onKeyDown={handleKeyDown}
                                            required={isFieldRequired(key)}
                                        />
                                    )}
                                </div>
                                    }
                                    </>
                                
                            );
                            })}
                        </div>
                    </div>
                    <div className="col-md-12 pe-3 mb-5 pb-1 mt-3">
                        <div className="row float-end">
                            <button className="btn btn-md btn-success me-3" type="submit">
                                <b>Submit</b>
                            </button>
                        </div>
                    </div>
                </form>
                </div>
            </div>
          </div>
          </div>
        </div>
        </div>
        <div className="color-dark">
        </div>
    </Modal>

            <Dialog
                open={openeditalert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to edit this Column? Any unsaved changes might be lost.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseeditalert}>No</Button>
                    <Button onClick={handleSaveClick}>Yes</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={opendeletealert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to delete this Leaves? This action cannot be undone.

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handledeleteClosealert}>No</Button>
                    <Button onClick={handleDeleteClick}>Yes</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={opendeletealert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to delete this? This action cannot be undone.

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handledeleteClosealert}>No</Button>
                    <Button onClick={handleDeleteClick}>Yes</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={opendeleteallalert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Are you sure?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to delete those selected Leaves ? This action cannot be undone.

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handledeleteallClosealert}>No</Button>
                    <Button onClick={handleDeleteallClick}>Yes</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={displayerroralert}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"file error ?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {displayerror}

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={setDisplayerroralertconsta}>ok</Button>
                </DialogActions>
            </Dialog>
        {/* </div> */}
        {/* </div> */}
        </div>
    )
}

export default CreateLeaves
